export const translations = {
  pt: {
    common: {
      yes: "SIM",
      select: "SELECIONAR",
      loading: "Carregando...",
      continue: "CONTINUAR"
    },
    header: {
      bookButton: "RESERVAR AGORA"
    },
    hero: {
      subtitle: "Sofisticação e qualidade ao seu dispor.",
      cta: "RESERVAR AGORA",
      promo: "Garanta até 20% de Desconto ao realizar sua reserva pelo nosso site oficial."
    },
    rooms: {
      sectionTitle: "ACOMODAÇÕES",
      mainTitle: "NOSSAS SUÍTES",
      description: "Seis categorias de hospedagem, cuidadosamente estruturadas para atender diferentes perfis com o mesmo padrão de excelência.",
      checkAvailability: "VERIFICAR DISPONIBILIDADE",
      disclaimer: "Tarifas sujeitas a alteração conforme disponibilidade e período da reserva.",
      items: {
        2: {
          title: "Suíte Casal",
          description: "Conforto sofisticado com vista privilegiada",
          features: ["Cama de Casal", "Frigobar", "Wi-Fi", "Mesa de Trabalho", "TV a cabo"]
        },
        6: {
          title: "Suíte Dupla Solteiro",
          description: "Perfeito para viagens a trabalho ou com amigos",
          features: ["2 Camas Solteiro", "Frigobar", "Wi-Fi", "Mesa de Trabalho", "TV a cabo"]
        },
        3: {
          title: "Suíte Tripla Casal",
          description: "O ápice da exclusividade e requinte",
          features: ["1 Cama de Casal e 1 de Solteiro", "Frigobar", "Wi-Fi", "Mesa de Trabalho", "TV a cabo"]
        },
        7: {
          title: "Suíte Tripla Solteiro",
          description: "Espaço e conforto para grupos e colegas de trabalho",
          features: ["3 Camas Solteiro", "Frigobar", "Wi-Fi", "Mesa de Trabalho", "TV a cabo"]
        },
        4: {
          title: "Suíte Quádrupla",
          description: "Espaço ideal para família ou pequenos grupos, com conforto completo",
          features: ["1 Cama de Casal e 2 de Solteiro", "Frigobar", "Wi-Fi", "Mesa de Trabalho", "TV a cabo"]
        },
        5: {
          title: "Suíte Adaptável",
          description: "Acessibilidade, praticidade e conforto, com estrutura pensada para PCD",
          features: ["Acessível (PCD)", "Frigobar", "Wi-Fi", "Mesa de Trabalho", "TV a cabo"]
        }
      }
    },
    location: {
      sectionTitle: "LOCALIZAÇÃO ESTRATÉGICA",
      mainTitle: "NO CORAÇÃO DE BRASÍLIA",
      accessTitle: "Bem-vindo à sua melhor escolha.",
      accessDescription: "Localizado no Núcleo Bandeirante, conhecido como a cidade pioneira de Brasília por ter sido palco das primeiras estruturas que deram origem à capital, nosso hotel combina acesso estratégico às principais regiões do Distrito Federal com a serenidade de um bairro tradicional e acolhedor.",
      pointsOfInterestTitle: "PONTOS DE INTERESSE",
      pointsOfInterestPart1: "PONTOS DE ",
      pointsOfInterestPart2: "INTERESSE",
      contactLabels: {
        address: "Endereço",
        phone: "Recepção",
        service: "Check-in",
        serviceHours: "das 13:00 a 12:00"
      },
      pointsOfInterest: [
        { 
          name: 'Aeroporto Internacional (BSB)', 
          distance: '7,0 km (Aprox. 12 min)', 
          description: 'Principal terminal aéreo da capital federal.'
        },
        { 
          name: 'Polícia Federal (Imigração)', 
          distance: '10,5 km (Aprox. 15 min)', 
          description: 'Setor de passaportes e imigração.'
        },
        { 
          name: 'Setor de Embaixadas Sul', 
          distance: '12,5 km (Aprox. 18 min)', 
          description: 'Concentração de missões diplomáticas.'
        },
        { 
          name: 'Embaixada dos EUA', 
          distance: '13,0 km (Aprox. 20 min)', 
          description: 'Representação diplomática dos Estados Unidos.'
        },
        { 
          name: 'CASV (Visto Americano)', 
          distance: '14,5 km (Aprox. 22 min)', 
          description: 'Centro de Atendimento ao Solicitante de Visto.'
        },
        { 
          name: 'Esplanada dos Ministérios', 
          distance: '16,0 km (Aprox. 25 min)', 
          description: 'Coração político e administrativo do Brasil.'
        },
        { 
          name: 'Estádio Nacional (Arena BRB)', 
          distance: '15,0 km (Aprox. 23 min)', 
          description: 'Palco de grandes eventos esportivos e shows.'
        },
        {
          name: 'ParkShopping Brasília',
          distance: '6,0 km (Aprox. 10 min)',
          description: 'O principal shopping do DF.'
        },
        {
          name: 'Rodoviária Interestadual',
          distance: '6,5 km (Aprox. 11 min)',
          description: 'Ponto de chegada e partida terrestre da capital.'
        }
      ]
    },
    amenities: {
      sectionTitle: "CONFORTO & LAZER",
      mainTitlePart1: "NOSSAS ",
      mainTitlePart2: "COMODIDADES",
      description: "Oferecemos uma infraestrutura completa, pensada para garantir que sua estadia seja tão produtiva quanto relaxante.",
      items: [
        { 
          name: 'Wi-Fi Ultra-Rápido', 
          description: 'Conexão de alta velocidade em todos os ambientes' 
        },
        { 
          name: 'Restaurante', 
          description: 'Gastronomia refinada com pratos à la carte e opções executivas' 
        },
        { 
          name: 'Café da Manhã', 
          description: 'Segunda a Sexta-feira: das 6h às 10h | Domingos e Feriados: das 7h às 10h30' 
        },
        { 
          name: 'Room Service 24h', 
          description: 'Atendimento exclusivo a qualquer momento' 
        },
        { 
          name: 'Estacionamento Privativo', 
          description: 'Vagas cobertas com segurança 24 horas' 
        },
        { 
          name: 'Mordomo Digital', 
          description: 'Nosso mordomo prestará atendimento dedicado, auxiliando em todas as solicitações e indicando experiências gastronômicas e passeios selecionados, com serviço impecável.' 
        },
        { 
          name: 'Elevador', 
          description: 'Acesso moderno e confortável a todos os andares' 
        },
        { 
          name: 'Segurança', 
          description: 'Monitoramento 24h e acesso controlado' 
        },
        { 
          name: 'Check-in Digital', 
          description: 'Processo ágil e sem burocracia' 
        },
        { 
          name: 'Secador de Cabelo', 
          description: 'Disponível em todas as suítes e também na recepção sob solicitação' 
        },
        { 
          name: 'Lavar e Passar', 
          description: 'Serviço de lavanderia terceirizado disponível para sua comodidade' 
        }
      ]
    },
    whatsappButton: {
      label: "Faça sua reserva agora",
      message: "Olá, equipe Alfa Plaza. Gostaria de verificar a disponibilidade de suítes para uma estada em Brasília. Poderiam me enviar os detalhes do tarifário e os serviços inclusos para envio"
    },
    map: {
      titlePart1: "COMO ",
      titlePart2: "CHEGAR",
      subtitle: "Localização privilegiada com fácil acesso aos principais pontos de Brasília.",
      button: "TRAÇAR ROTA ATÉ O HOTEL"
    },
    footer: {
      description: "Referência em hospitalidade no Distrito Federal, oferecendo conforto, localização estratégica e padrão elevado de atendimento para quem busca a escolha certa em Brasília.",
      contactTitle: "CONTATO",
      termsPrivacy: "Termos de Uso | Política de Privacidade",
      rightsReserved: "Alfa Plaza Hotel. Todos os direitos reservados.",
      developedBy: "Desenvolvido por"
    },
    reservation: {
      title: "Reserva",
      request: "Solicitação",
      hub: {
        bookNow: "Reservar Agora",
        bookNowDesc: "Individual ou Família",
        corporate: "Reserva Faturada",
        corporateDesc: "Exclusivo para Empresas",
        groups: "Grupos e Eventos",
        groupsDesc: "Solicitar Cotação Especial",
        partnership: "Parceria Comercial",
        partnershipDesc: "Seja um Parceiro Alfa Plaza"
      },
      suiteSelection: {
        titleIndividual: "Escolha sua Suíte",
        titleGroup: "Selecione as categorias do grupo",
        selected: "Selecionado",
        nextStep: "PRÓXIMO PASSO"
      },
      dates: {
        checkIn: "Data de Check-in",
        checkOut: "Data de Check-out",
        nextStep: "PRÓXIMO PASSO"
      },
      guests: {
        titleGroup: "Quantas pessoas no grupo?",
        titleIndividual: "Quantos adultos?",
        adult1: "1 Adulto",
        adults2: "2 Adultos",
        adults3: "3 Adultos",
        adults4: "4 Adultos",
        adults5Plus: "5+ Adultos",
        hasChildren: "Viajando com crianças?",
        childrenCourtesy: "Cortesia de 1 criança de até 5 anos por quarto.",
        childrenCount: "Quantas crianças?",
        allOver5: "Todos acima de 5 anos?",
        allOver5Many: "Todas tem +5 anos",
        oneChildOver5: "Tem mais que 5 anos?",
        childAgeLabel: "Idade da criança",
        childAgePlaceholder: "Informe a idade da criança",
        childrenWarning: "*Crianças acima de 5 anos possuem tarifa diferenciada.",
        nextStep: "PRÓXIMO PASSO"
      },
      arrivalTime: {
        title: "Horário de Chegada",
        subtitle: "Previsão estimada para sua recepção",
        almostThere: "QUASE LÁ"
      },
      contact: {
        title: "Dados de Contato",
        subtitle: "Finalize para enviar sua reserva",
        nameLabel: "Nome Completo",
        namePlaceholder: "Qual seu nome?",
        emailLabel: "E-mail",
        emailPlaceholder: "seu@email.com",
        whatsappLabel: "WhatsApp",
        whatsappPlaceholder: "(00) 00000-0000",
        disclaimer: "Ao clicar em finalizar, você será redirecionado para o WhatsApp do nosso setor de reservas para validação final. Quando abrir o WhatsApp, basta enviar a mensagem gerada automaticamente para o número do hotel.",
        finish: "FINALIZAR E ENVIAR"
      },
      rules: {
        corporateTitle: "Diretrizes Corporativas",
        partnershipTitle: "Expansão Comercial",
        corporate: [
          "• A análise de aprovação de crédito está condicionada à existência de uma pré-reserva ativa no sistema.",
          "• Faturamento exclusivo para empresas com cadastro corporativo aprovado.",
          "• Prazo de pagamento: 15 ou 30 dias após a data de check-out.",
          "• Necessário envio de autorização formal em papel timbrado e cópia do Cartão CNPJ atualizado.",
          "• É obrigatória a confirmação prévia de garantia de no-show."
        ],
        partnership: [
          "• Condições especiais para agências e operadoras.",
          "• Acordos de volume para empresas locais.",
          "• Gestão dedicada para contas comerciais."
        ],
        sendEmail: "ENVIAR SOLICITAÇÃO POR E-MAIL"
      },
      types: {
        individual: "Reserva Individual",
        corporate: "Reserva Faturada",
        groups: "Grupos e Eventos",
        partnership: "Parceria Comercial",
        celebrations: "Recepção VIP & Homenagens"
      },
      experiences: {
        'welcome-vip': {
          title: 'Boas-Vindas VIP',
          focus: 'Recepção de alto padrão no apartamento para ocasiões únicas.',
          setup: 'Cartão nominal escrito à mão, águas premium e macarons/trufas artesanais.'
        },
        'boutique-exp': {
          title: 'Lounge Privativo',
          focus: 'Recepção sofisticada para casais ou executivos.',
          setup: 'Tábua de frios, meia garrafa de vinho e arranjo floral minimalista.'
        },
        'guest-honor': {
          title: 'Convidado de Honra',
          focus: 'Comemorações marcantes e hóspedes VIP.',
          setup: 'Bandeja de frutas frescas e chocolates, garrafa de vinho ou espumante, roupões para uso na estadia e café da manhã servido no quarto.'
        }
      },
      whatsapp: {
        title: "RESERVA - ALFA PLAZA HOTEL",
        client: "Cliente",
        type: "Tipo de reserva",
        category: "Categoria",
        vip: "Recepção VIP",
        people: "Pessoas",
        children: "Crianças",
        ages: "Idades",
        dates: "Datas",
        arrival: "Chegada prevista",
        waitMessage: "Aguarde um momento. Nossa equipe de recepção iniciará o seu atendimento em instantes.",
        none: "Nenhuma",
        allOver5: "Todas acima de 5 anos",
        includesUnder5: "Inclui menores de 5 anos",
        unspecified: "Não especificada"
      }
    }
  },
  en: {
    common: {
      yes: "YES",
      select: "SELECT",
      loading: "Loading...",
      continue: "CONTINUE"
    },
    header: {
      bookButton: "BOOK NOW"
    },
    hero: {
      subtitle: "Sophistication and quality at your disposal.",
      cta: "BOOK NOW",
      promo: "Get up to 20% discount by booking through our official website."
    },
    rooms: {
      sectionTitle: "ACCOMMODATIONS",
      mainTitle: "OUR SUITES",
      description: "Six categories of accommodation, carefully structured to meet different profiles with the same standard of excellence.",
      checkAvailability: "CHECK AVAILABILITY",
      disclaimer: "Rates subject to change depending on availability and reservation period.",
      items: {
        2: {
          title: "Double Suite",
          description: "Sophisticated comfort with a privileged view",
          features: ["Double Bed", "Minibar", "Wi-Fi", "Work Desk", "Cable TV"]
        },
        6: {
          title: "Twin Suite",
          description: "Perfect for business trips or friends",
          features: ["2 Single Beds", "Minibar", "Wi-Fi", "Work Desk", "Cable TV"]
        },
        3: {
          title: "Triple Suite (Double + Single)",
          description: "The pinnacle of exclusivity and refinement",
          features: ["1 Double Bed and 1 Single Bed", "Minibar", "Wi-Fi", "Work Desk", "Cable TV"]
        },
        7: {
          title: "Triple Single Suite",
          description: "Space and comfort for groups and colleagues",
          features: ["3 Single Beds", "Minibar", "Wi-Fi", "Work Desk", "Cable TV"]
        },
        4: {
          title: "Quadruple Suite",
          description: "Ideal space for family or small groups, with complete comfort",
          features: ["1 Double Bed and 2 Single Beds", "Minibar", "Wi-Fi", "Work Desk", "Cable TV"]
        },
        5: {
          title: "Accessible Suite",
          description: "Accessibility, practicality and comfort, with structure designed for PWD",
          features: ["Accessible (PWD)", "Minibar", "Wi-Fi", "Work Desk", "Cable TV"]
        }
      }
    },
    location: {
      sectionTitle: "STRATEGIC LOCATION",
      mainTitle: "IN THE HEART OF BRASÍLIA",
      accessTitle: "Welcome to your best choice.",
      accessDescription: "Located in Núcleo Bandeirante, known as the pioneer city of Brasília for having hosted the first structures that gave rise to the capital, our hotel combines strategic access to the main regions of the Federal District with the serenity of a traditional and welcoming neighborhood.",
      pointsOfInterestTitle: "POINTS OF INTEREST",
      pointsOfInterestPart1: "POINTS OF ",
      pointsOfInterestPart2: "INTEREST",
      contactLabels: {
        address: "Address",
        phone: "Reception",
        service: "Check-in",
        serviceHours: "from 13:00 to 12:00"
      },
      pointsOfInterest: [
        { 
          name: 'International Airport (BSB)', 
          distance: '7.0 km (Approx. 12 min)', 
          description: 'Main air terminal of the federal capital.'
        },
        { 
          name: 'Federal Police (Immigration)', 
          distance: '10.5 km (Approx. 15 min)', 
          description: 'Passport and immigration sector.'
        },
        { 
          name: 'South Embassy Sector', 
          distance: '12.5 km (Approx. 18 min)', 
          description: 'Concentration of diplomatic missions.'
        },
        { 
          name: 'US Embassy', 
          distance: '13.0 km (Approx. 20 min)', 
          description: 'Diplomatic representation of the United States.'
        },
        { 
          name: 'CASV (American Visa)', 
          distance: '14.5 km (Approx. 22 min)', 
          description: 'Applicant Service Center for Visas.'
        },
        { 
          name: 'Ministries Esplanade', 
          distance: '16.0 km (Approx. 25 min)', 
          description: 'Political and administrative heart of Brazil.'
        },
        { 
          name: 'National Stadium (Arena BRB)', 
          distance: '15.0 km (Approx. 23 min)', 
          description: 'Stage for major sporting events and shows.'
        },
        {
          name: 'ParkShopping Brasília',
          distance: '6.0 km (Approx. 10 min)',
          description: 'The main shopping mall in the Federal District.'
        },
        {
          name: 'Interstate Bus Terminal',
          distance: '6.5 km (Approx. 11 min)',
          description: 'Main ground arrival and departure point of the capital.'
        }
      ]
    },
    amenities: {
      sectionTitle: "COMFORT & LEISURE",
      mainTitlePart1: "OUR ",
      mainTitlePart2: "AMENITIES",
      description: "We offer a complete infrastructure, designed to ensure your stay is as productive as it is relaxing.",
      items: [
        { 
          name: 'Ultra-Fast Wi-Fi', 
          description: 'High-speed connection in all environments' 
        },
        { 
          name: 'Restaurant', 
          description: 'Refined gastronomy with à la carte dishes and executive options' 
        },
        { 
          name: 'Breakfast', 
          description: 'Monday to Friday: 6am to 10am | Sundays and Holidays: 7am to 10:30am' 
        },
        { 
          name: '24h Room Service', 
          description: 'Exclusive service at any time' 
        },
        { 
          name: 'Private Parking', 
          description: 'Covered spaces with 24-hour security' 
        },
        { 
          name: 'Digital Butler', 
          description: 'Our butler will provide dedicated service, assisting with all requests and recommending selected gastronomic experiences and tours, with impeccable service.' 
        },
        { 
          name: 'Elevator', 
          description: 'Modern and comfortable access to all floors' 
        },
        { 
          name: 'Security', 
          description: '24h monitoring and controlled access' 
        },
        { 
          name: 'Digital Check-in', 
          description: 'Fast and bureaucracy-free process' 
        },
        { 
          name: 'Hair Dryer', 
          description: 'Available in all suites and also at the reception upon request' 
        },
        { 
          name: 'Laundry & Ironing', 
          description: 'Third-party laundry service available for your convenience' 
        }
      ]
    },
    whatsappButton: {
      label: "Book your stay now",
      message: "Hello, Alfa Plaza team. I would like to check the availability of suites for a stay in Brasília. Could you send me the price details and included services?"
    },
    map: {
      titlePart1: "HOW TO ",
      titlePart2: "GET HERE",
      subtitle: "Privileged location with easy access to the main points of Brasília.",
      button: "GET DIRECTIONS TO HOTEL"
    },
    footer: {
      description: "Reference in hospitality in the Federal District, offering comfort, strategic location and high standard of service for those seeking the right choice in Brasília.",
      contactTitle: "CONTACT",
      termsPrivacy: "Terms of Use | Privacy Policy",
      rightsReserved: "Alfa Plaza Hotel. All rights reserved.",
      developedBy: "Developed by"
    },
    reservation: {
      title: "Reservation",
      request: "Request",
      hub: {
        bookNow: "Book Now",
        bookNowDesc: "Individual or Family",
        corporate: "Billed Reservation",
        corporateDesc: "Exclusive for Companies",
        groups: "Groups and Events",
        groupsDesc: "Request Special Quote",
        partnership: "Commercial Partnership",
        partnershipDesc: "Be an Alfa Plaza Partner"
      },
      suiteSelection: {
        titleIndividual: "Choose your Suite",
        titleGroup: "Select group categories",
        selected: "Selected",
        nextStep: "NEXT STEP"
      },
      dates: {
        checkIn: "Check-in Date",
        checkOut: "Check-out Date",
        nextStep: "NEXT STEP"
      },
      guests: {
        titleGroup: "How many people in the group?",
        titleIndividual: "How many adults?",
        adult1: "1 Adult",
        adults2: "2 Adults",
        adults3: "3 Adults",
        adults4: "4 Adults",
        adults5Plus: "5+ Adults",
        hasChildren: "Traveling with children?",
        childrenCourtesy: "Courtesy for 1 child up to 5 years old per room.",
        childrenCount: "How many children?",
        allOver5: "All over 5 years old?",
        allOver5Many: "All are 5+ years old",
        childAgeLabel: "Child age",
        childAgePlaceholder: "Enter child's age",
        childrenWarning: "*Standard rates apply for children over 5.",
        nextStep: "NEXT STEP"
      },
      arrivalTime: {
        title: "Arrival Time",
        subtitle: "Estimated forecast for your reception",
        almostThere: "ALMOST THERE"
      },
      contact: {
        title: "Contact Details",
        subtitle: "Finish to send your reservation",
        nameLabel: "Full Name",
        namePlaceholder: "What is your name?",
        emailLabel: "E-mail",
        emailPlaceholder: "your@email.com",
        whatsappLabel: "WhatsApp",
        whatsappPlaceholder: "(00) 00000-0000",
        disclaimer: "By clicking finish, you will be redirected to our reservation sector WhatsApp for final validation. When WhatsApp opens, simply send the automatically generated message to the hotel number.",
        finish: "FINISH AND SEND"
      },
      rules: {
        corporateTitle: "Corporate Guidelines",
        partnershipTitle: "Commercial Expansion",
        corporate: [
          "• Credit approval analysis is conditioned on the existence of an active pre-reservation in the system.",
          "• Direct billing available exclusively for companies with approved corporate registration.",
          "• Payment term: 15 or 30 days after check-out date.",
          "• Formal authorization on letterhead and copy of updated CNPJ Card required.",
          "• Prior confirmation of no-show guarantee is required."
        ],
        partnership: [
          "• Special conditions for agencies and operators.",
          "• Volume agreements for local companies.",
          "• Dedicated management for commercial accounts."
        ],
        sendEmail: "SEND REQUEST BY E-MAIL"
      },
      types: {
        individual: "Individual Reservation",
        corporate: "Billed Reservation",
        groups: "Groups and Events",
        partnership: "Commercial Partnership",
        celebrations: "VIP Reception & Tributes"
      },
      experiences: {
        'welcome-vip': {
          title: 'VIP Welcome',
          focus: 'High-standard in-room reception for unique occasions.',
          setup: 'Handwritten name card, premium water, and artisanal macarons/truffles.'
        },
        'boutique-exp': {
          title: 'Private Lounge',
          focus: 'Sophisticated reception for couples or executives.',
          setup: 'Cold cuts board, half bottle of wine, and minimalist floral arrangement.'
        },
        'guest-honor': {
          title: 'Guest of Honor',
          focus: 'Milestone celebrations and VIP guests.',
          setup: 'Tray of fresh fruits and chocolates, bottle of wine or sparkling wine, robes for use during stay, and breakfast served in the room.'
        }
      },
      whatsapp: {
        title: "RESERVATION - ALFA PLAZA HOTEL",
        client: "Client",
        type: "Reservation type",
        category: "Category",
        vip: "VIP Reception",
        people: "People",
        children: "Children",
        ages: "Ages",
        dates: "Dates",
        arrival: "Estimated arrival",
        waitMessage: "Please wait a moment. Our reception team will start your service shortly.",
        none: "None",
        allOver5: "All over 5 years old",
        includesUnder5: "Includes children under 5",
        unspecified: "Unspecified"
      }
    }
  },
  es: {
    common: {
      yes: "SÍ",
      select: "SELECCIONAR",
      loading: "Cargando...",
      continue: "CONTINUAR"
    },
    header: {
      bookButton: "RESERVAR AHORA"
    },
    hero: {
      subtitle: "Sofisticación y calidad a su disposición.",
      cta: "RESERVAR AHORA",
      promo: "Obtenga hasta un 20% de descuento reservando a través de nuestro sitio web oficial."
    },
    rooms: {
      sectionTitle: "ALOJAMIENTOS",
      mainTitle: "NUESTRAS SUITES",
      description: "Seis categorías de alojamiento, cuidadosamente estructuradas para atender diferentes perfiles con el mismo estándar de excelencia.",
      checkAvailability: "VERIFICAR DISPONIBILIDAD",
      disclaimer: "Tarifas sujetas a cambios según disponibilidad y período de reserva.",
      items: {
        2: {
          title: "Suite Matrimonial",
          description: "Confort sofisticado con vista privilegiada",
          features: ["Cama de Matrimonio", "Frigobar", "Wi-Fi", "Escritorio", "TV por cable"]
        },
        6: {
          title: "Suite Doble Twin",
          description: "Perfecto para viajes de trabajo o con amigos",
          features: ["2 Camas Individuales", "Frigobar", "Wi-Fi", "Escritorio", "TV por cable"]
        },
        3: {
          title: "Suite Triple (Matrimonial + Individual)",
          description: "La cúspide de la exclusividad y el refinamiento",
          features: ["1 Cama de Matrimonio y 1 Individual", "Frigobar", "Wi-Fi", "Escritorio", "TV por cable"]
        },
        7: {
          title: "Suite Triple Individual",
          description: "Espacio y confort para grupos y colegas de trabajo",
          features: ["3 Camas Individuales", "Frigobar", "Wi-Fi", "Escritorio", "TV por cable"]
        },
        4: {
          title: "Suite Cuádruple",
          description: "Espacio ideal para familia o pequeños grupos, con confort completo",
          features: ["1 Cama de Matrimonio y 2 Individuales", "Frigobar", "Wi-Fi", "Escritorio", "TV por cable"]
        },
        5: {
          title: "Suite Adaptable",
          description: "Accesibilidad, practicidad y confort, con estructura pensada para PMR",
          features: ["Accesible (PMR)", "Frigobar", "Wi-Fi", "Escritorio", "TV por cable"]
        }
      }
    },
    location: {
      sectionTitle: "UBICACIÓN ESTRATÉGICA",
      mainTitle: "EN EL CORAZÓN DE BRASILIA",
      accessTitle: "Bienvenido a su mejor elección.",
      accessDescription: "Ubicado en Núcleo Bandeirante, conocido como la ciudad pionera de Brasilia por haber sido escenario de las primeras estructuras que dieron origen a la capital, nuestro hotel combina acceso estratégico a las principales regiones del Distrito Federal con la serenidad de un barrio tradicional y acogedor.",
      pointsOfInterestTitle: "PUNTOS DE INTERÉS",
      pointsOfInterestPart1: "PUNTOS DE ",
      pointsOfInterestPart2: "INTERÉS",
      contactLabels: {
        address: "Dirección",
        phone: "Recepción",
        service: "Check-in",
        serviceHours: "de 13:00 a 12:00"
      },
      pointsOfInterest: [
        { 
          name: 'Aeropuerto Internacional (BSB)', 
          distance: '7,0 km (Aprox. 12 min)', 
          description: 'Principal terminal aérea de la capital federal.'
        },
        { 
          name: 'Policía Federal (Inmigración)', 
          distance: '10,5 km (Aprox. 15 min)', 
          description: 'Sector de pasaportes e inmigración.'
        },
        { 
          name: 'Sector de Embajadas Sur', 
          distance: '12,5 km (Aprox. 18 min)', 
          description: 'Concentración de misiones diplomáticas.'
        },
        { 
          name: 'Embajada de EE.UU.', 
          distance: '13,0 km (Aprox. 20 min)', 
          description: 'Representación diplomática de los Estados Unidos.'
        },
        { 
          name: 'CASV (Visa Americana)', 
          distance: '14,5 km (Aprox. 22 min)', 
          description: 'Centro de Atención al Solicitante de Visa.'
        },
        { 
          name: 'Explanada de los Ministerios', 
          distance: '16,0 km (Aprox. 25 min)', 
          description: 'Corazón político y administrativo de Brasil.'
        },
        { 
          name: 'Estadio Nacional (Arena BRB)', 
          distance: '15,0 km (Aprox. 23 min)', 
          description: 'Escenario de grandes eventos deportivos y espectáculos.'
        },
        {
          name: 'ParkShopping Brasília',
          distance: '6,0 km (Aprox. 10 min)',
          description: 'El principal centro comercial del DF.'
        },
        {
          name: 'Estación de Autobuses Interestatal',
          distance: '6,5 km (Aprox. 11 min)',
          description: 'Punto de llegada y partida terrestre de la capital.'
        }
      ]
    },
    amenities: {
      sectionTitle: "CONFORT & OCIO",
      mainTitlePart1: "NUESTRAS ",
      mainTitlePart2: "COMODIDADES",
      description: "Ofrecemos una infraestructura completa, diseñada para garantizar que su estancia sea tanto productiva como relajante.",
      items: [
        { 
          name: 'Wi-Fi Ultra-Rápido', 
          description: 'Conexión de alta velocidad en todos los ambientes' 
        },
        { 
          name: 'Restaurante', 
          description: 'Gastronomía refinada con platos a la carta y opciones ejecutivas' 
        },
        { 
          name: 'Desayuno', 
          description: 'Lunes a Viernes: de 6:00 a 10:00 | Domingos y Festivos: de 7:00 a 10:30' 
        },
        { 
          name: 'Servicio de Habitaciones 24h', 
          description: 'Atención exclusiva en cualquier momento' 
        },
        { 
          name: 'Aparcamiento Privado', 
          description: 'Plazas cubiertas con seguridad 24 horas' 
        },
        { 
          name: 'Mayordomo Digital', 
          description: 'Nuestro mayordomo brindará una atención dedicada, ayudando con todas las solicitudes y recomendando experiencias gastronómicas y recorridos seleccionados, con un servicio impecable.' 
        },
        { 
          name: 'Ascensor', 
          description: 'Acceso moderno y cómodo a todas las plantas' 
        },
        { 
          name: 'Seguridad', 
          description: 'Monitoreo 24h e información controlada' 
        },
        { 
          name: 'Check-in Digital', 
          description: 'Proceso ágil y sin burocracia' 
        },
        { 
          name: 'Secador de Pelo', 
          description: 'Disponible en todas las suites y también en recepción bajo petición' 
        },
        { 
          name: 'Lavado y Planchado', 
          description: 'Servicio de lavandería externo disponible para su comodidad' 
        }
      ]
    },
    whatsappButton: {
      label: "Haga su reserva ahora",
      message: "Hola, equipo de Alfa Plaza. Me gustaría consultar la disponibilidad de suites para una estancia em Brasilia. ¿Podrían enviarme los detalles de las tarifas y los servicios incluidos?"
    },
    map: {
      titlePart1: "CÓMO ",
      titlePart2: "LLEGAR",
      subtitle: "Ubicación privilegiada con fácil acceso a los principales puntos de Brasilia.",
      button: "TRAZAR RUTA HASTA O HOTEL"
    },
    footer: {
      description: "Referencia en hospitalidad en el Distrito Federal, ofreciendo confort, ubicación estratégica y alto nivel de atención para quienes buscan la elección correcta en Brasilia.",
      contactTitle: "CONTACTO",
      termsPrivacy: "Términos de Uso | Política de Privacidad",
      rightsReserved: "Alfa Plaza Hotel. Todos los derechos reservados.",
      developedBy: "Desarrollado por"
    },
    reservation: {
      title: "Reserva",
      request: "Solicitud",
      hub: {
        bookNow: "Reservar Ahora",
        bookNowDesc: "Individual o Familia",
        corporate: "Pago Directo",
        corporateDesc: "Exclusivo para Empresas",
        groups: "Grupos y Eventos",
        groupsDesc: "Solicitar Cotización Especial",
        partnership: "Asociación Comercial",
        partnershipDesc: "Sea un Socio Alfa Plaza"
      },
      suiteSelection: {
        titleIndividual: "Elija su Suite",
        titleGroup: "Seleccione las categorías del grupo",
        selected: "Seleccionado",
        nextStep: "PRÓXIMO PASO"
      },
      dates: {
        checkIn: "Fecha de Check-in",
        checkOut: "Fecha de Check-out",
        nextStep: "PRÓXIMO PASO"
      },
      guests: {
        titleGroup: "¿Cuántas personas en el grupo?",
        titleIndividual: "¿Cuántos adultos?",
        adult1: "1 Adulto",
        adults2: "2 Adultos",
        adults3: "3 Adultos",
        adults4: "4 Adultos",
        adults5Plus: "5+ Adultos",
        hasChildren: "¿Viajando con niños?",
        childrenCourtesy: "Cortesía de 1 niño de hasta 5 años por habitación.",
        childrenCount: "¿Cuántos niños?",
        allOver5: "¿Todos mayores de 5 años?",
        allOver5Many: "Todos tienen +5 años",
        childAgeLabel: "Edad del niño",
        childAgePlaceholder: "Informe la edad del niño",
        childrenWarning: "*Se aplican tarifas estándar para niños mayores de 5 años.",
        nextStep: "PRÓXIMO PASO"
      },
      arrivalTime: {
        title: "Hora de Llegada",
        subtitle: "Previsión estimada para su recepción",
        almostThere: "CASI LISTO"
      },
      contact: {
        title: "Datos de Contacto",
        subtitle: "Finalice para enviar su reserva",
        nameLabel: "Nombre Completo",
        namePlaceholder: "¿Cuál es su nombre?",
        emailLabel: "E-mail",
        emailPlaceholder: "su@email.com",
        whatsappLabel: "WhatsApp",
        whatsappPlaceholder: "(00) 00000-0000",
        disclaimer: "Al hacer clic en finalizar, será redirigido al WhatsApp de nuestro sector de reservas para validación final. Al abrir WhatsApp, simplemente envíe el mensaje generado automáticamente al número del hotel.",
        finish: "FINALIZAR Y ENVIAR"
      },
      rules: {
        corporateTitle: "Directrices Corporativas",
        partnershipTitle: "Expansión Comercial",
        corporate: [
          "• El análisis de crédito está sujeto a la existencia de una pre-reserva activa en el sistema.",
          "• Facturación exclusiva para empresas con registro corporativo aprobado.",
          "• Plazo de pago: 15 o 30 días después de la fecha de check-out.",
          "• Se requiere autorización formal en papel con membrete y copia de la Tarjeta CNPJ actualizada.",
          "• Es obligatoria la confirmación previa de garantía de no-show."
        ],
        partnership: [
          "• Condiciones especiales para agencias y operadores.",
          "• Acuerdos de volumen para empresas locales.",
          "• Gestión dedicada para cuentas comerciales."
        ],
        sendEmail: "ENVIAR SOLICITUD POR E-MAIL"
      },
      types: {
        individual: "Reserva Individual",
        corporate: "Reserva Facturada",
        groups: "Grupos y Eventos",
        partnership: "Asociación Comercial",
        celebrations: "Recepción VIP y Homenajes"
      },
      experiences: {
        'welcome-vip': {
          title: 'Bienvenida VIP',
          focus: 'Recepción de alto nivel en la habitación para ocasiones únicas.',
          setup: 'Tarjeta con nombre escrita a mano, agua premium y macarons/trufas artesanales.'
        },
        'boutique-exp': {
          title: 'Lounge Privado',
          focus: 'Recepción sofisticada para parejas o ejecutivos.',
          setup: 'Tabla de embutidos, media botella de vino y arreglo floral minimalista.'
        },
        'guest-honor': {
          title: 'Invitado de Honor',
          focus: 'Celebraciones importantes e invitados VIP.',
          setup: 'Bandeja de frutas frescas y chocolates, botella de vino o espumoso, batas para uso durante la estancia y desayuno servido en la habitación.'
        }
      },
      whatsapp: {
        title: "RESERVA - ALFA PLAZA HOTEL",
        client: "Cliente",
        type: "Tipo de reserva",
        category: "Categoría",
        vip: "Recepción VIP",
        people: "Personas",
        children: "Niños",
        ages: "Edades",
        dates: "Fechas",
        arrival: "Llegada prevista",
        waitMessage: "Espere un momento. Nuestro equipo de recepción iniciará su atención en instantes.",
        none: "Ninguno",
        allOver5: "Todos mayores de 5 años",
        includesUnder5: "Incluye menores de 5 años",
        unspecified: "No especificada"
      }
    }
  }
};
